import * as dotenv from 'dotenv'
dotenv.config()

const service = {
  NAME: process.env.REACT_APP_SERVICE_NAME || 'haup-partners',
}

const authService = {
  URL: process.env.REACT_APP_TS_AUTHENTICATION_URL,
  AUTH_PROJECT: process.env.REACT_APP_AUTH_PROJECT,
}

const webserverService = {
  URL: process.env.REACT_APP_WS,
}

const restfulService = {
  URL: process.env.REACT_APP_TS_RESTFUL_API_URL,
}

const credentials = {
  freshchat: {
    TOKEN: process.env.REACT_APP_FRESHCHAT_TOKEN,
  },
}

const uploadService = {
  URL: process.env.REACT_APP_TS_UPLOAD,
}

const cmsService = {
  URL: process.env.REACT_APP_CMS,
}

const omiseService = {
  PUBLIC_KEY: process.env.REACT_APP_OMISE_PUBLIC_KEY,
}

const config = {
  service,
  authService,
  restfulService,
  credentials,
  uploadService,
  cmsService,
  webserverService,
  omiseService,
}

export default config
